<div class="row mt-3 mb-3" *ngIf="flashMessages && flashMessages.length > 0">
  <div class="col col-md-8">
    <div class="alert" role="alert">
      <div class="row">
        <div class="col">
          <app-flash-message *ngFor="let m of flashMessages" [message]="m"></app-flash-message>
        </div>
        <div class="col-auto">
          <mat-icon>flash_on</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>
